import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getUtility(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createUtility(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/utility" + pathname, body);
}

export async function updateUtility(pathname, queryParams, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/utility" + pathname + queryParams, body);
}

export async function deleteUtility(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/utility" + pathname + queryParams);
}
